import BossModel from "@/models/BossModel";
import File from '@/models/File/File';
import { saveAs } from 'file-saver';
import camelCase from 'lodash/camelCase';

export default class Download extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'download';

    /**
     *
     * @type {string}
     */
    static entity = 'downloads';

    static TYPES = [
        {value: 1, text: 'Vliegmaatschappij'},
        {value: 2, text: 'Land'},
        {value: 3, text: 'Regio'},
        {value: 4, text: 'Product'},
    ];

    static fields() {
		return {
			id: this.attr(null),
			file_id: this.attr(null),
			name: this.attr(null),
			description: this.attr(null),
			code: this.attr(null),
			is_active: this.attr(null),
			is_default_generated_voucher: this.attr(null),
			is_default_inactive: this.attr(null),
			product_id: this.attr(null),
			airline_id: this.attr(null),
			region_id: this.attr(null),
			country_id: this.attr(null),
			service_label_cid: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            file: this.belongsTo(File, 'file_id'),
		}
	}

    File(){
        return this.getRelated('file');
    }

    Type() {
        return this.constructor.Type(this);
    }

    TypeNumber() {
        if (this.product_id !== null) {
            return 4;
        }
        if (this.airline_id !== null) {
            return 1;
        }
        if (this.region_id !== null) {
            return 3;
        }
        if (this.country_id !== null) {
            return 2;
        }
        return null;
    }

    static Type(download) {
        if (download.product_id !== null) {
            return 'Product / Ticket';
        }
        if (download.airline_id !== null) {
            return 'Vliegmaatschappij';
        }
        if (download.region_id !== null) {
            return 'Regio';
        }
        if (download.country_id !== null) {
            return 'Land';
        }
        return 'Onbekend';
    }

    download() {
        return this.constructor.api().action(this.id + '/download').getBlob().then(response => {
            return saveAs(response, camelCase(this.name) + '.pdf');
        });
    }

}
